
document.addEventListener('DOMContentLoaded', function() {
   document.addEventListener('click', function(event) {
    if (event.target.matches('.product-card__image')) {
      const handleValue = event.target.parentElement.parentElement.parentElement.getAttribute('handle');
       localStorage.setItem('last-product-clicked', `${handleValue}`);
    }
 });
  function scrollToElementByValue(handleValue) {
    const element = document.querySelector(handleValue);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        console.log(`Element with handle '${handleValue}' not found.`);
    }
}
  if (window.location.pathname.includes('/collections/')) {
    if(localStorage.getItem('last-product-clicked')){
         scrollToElementByValue(`[handle="${localStorage.getItem('last-product-clicked')}"]`);
    }
  }
  var href = window.location.href;
  if(!href.includes("/products/")){
    sessionStorage.setItem('previousLink',  window.location.href);
  }
  var breadcrumbCollection = document.querySelector('#breadcrumbCollection');
  var previousLinkTitle = sessionStorage.getItem('previousLink').split('/').at(-1);
  var previousLinkTitle = previousLinkTitle.split('?')[0];
  if(breadcrumbCollection){
    if(previousLinkTitle != "shop" && sessionStorage.getItem('previousLink') != "/"){
      breadcrumbCollection.innerHTML = `
      <a href="${sessionStorage.getItem('previousLink')}" aria-current="page" class="smallcaps">${previousLinkTitle}</a>`;
    }else{
      breadcrumbCollection.remove();
    }
  }

});